/**
 * Pure UI state for the Edit tab. Lives in zustand because:
 *  - it's shared across Sidebar, Toolbar, WeekGrid, and WindowEditorDialog
 *  - none of it should ever round-trip through the API
 *
 * Do NOT move schedule data into this store — that lives in `data/useScheduleSource.ts`
 * (the API-replaceable seam). Mixing the two would make the API swap painful.
 */
import { create } from 'zustand'
import type { EditorPrefill, ManagerId } from '../types.ts'

interface EditViewState {
  selectedManagerId: ManagerId | null
  visibleDate: Date
  editor: EditorPrefill | null
  setSelectedManager: (id: ManagerId | null) => void
  setVisibleDate: (d: Date) => void
  openEditor: (p: EditorPrefill) => void
  closeEditor: () => void
}

export const useEditViewState = create<EditViewState>((set) => ({
  selectedManagerId: null,
  visibleDate: new Date(),
  editor: null,
  setSelectedManager: (selectedManagerId) => set({ selectedManagerId }),
  setVisibleDate: (visibleDate) => set({ visibleDate }),
  openEditor: (editor) => set({ editor }),
  closeEditor: () => set({ editor: null }),
}))
